import React, { useEffect } from "react";
import { beneficiarios } from "../../json/beneficiarios";
import "./beneficiarios.css";

const Beneficiarios = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container beneficiarios-container">
      <div className='row'>
            <div className='col_12'>
                <div className='beneficiarios_title'>
                    <h1>Beneficiarios</h1>
                </div>
            </div>
        </div>
      <div className="row">        
        {beneficiarios.map((item, index) => (
          <div className="col-md-3">
            <div className="card">            
              <div className="card-body">
              <div className="sec_convocatoria">
                    <h5>{item.nombre} <p className="anio">{item.anio}</p></h5>
                  </div>
              </div>
              <hr className="hr-gob" />
                  <div className="row mt-2">
                    <div class="btn-group" role="group">
                      {item.urls !== undefined ? (
                        item.urls.map((url) => (
                          <a
                            className={"btn btn-sm btn-" + url.id}
                            href={url.enlace}
                            target={"_blank"}
                          >
                            {url.nombrelink}
                          </a>
                        ))
                      ) : (
                        <>
                          <p className="doc">Sin Beneficiarios</p>
                        </>
                      )}
                    </div>
                  </div>
            </div>
          </div>
        ))}
      </div>
      <hr className="hr-gob" />
    </div>
  );
};

export default Beneficiarios;
